import http from "./config/NetworkClient";

// Several places (routes/index.js, SignInForm.jsx, TherapyTab/index.js) call
// getTherapyIndex() independently around login/mount, firing off duplicate
// requests in the same tick. Coalesce concurrent calls into one in-flight
// request instead of restructuring all those call sites.
let therapyIndexPromise = null;

export default class TherapyApi {
  static async getTherapyIndex() {
    if (therapyIndexPromise) return therapyIndexPromise;
    therapyIndexPromise = http
      .get("/client/public/therapy_index?limit=3")
      .finally(() => {
        therapyIndexPromise = null;
      });
    return therapyIndexPromise;
  }
  static async getAppointmentList(payload) {
    const response = await http.get("/client/public/appointments", payload);
    return response;
  }

  static async getTherapistProfile(id, submission_id = null) {
    let url;
    const locationId = window.localStorage.getItem("locationId");


    const formatStudioId = locationId?.split(",").map((item) => {
      return `studio_location_id=${item.trim()}`;
    });
    
    const formatStudioIdForQuery = formatStudioId?.join("&");

    if (submission_id && !locationId) {
      url = `/client/booking/instructor-profile/${id}?submission_id=${submission_id}`;
    } else if (!submission_id && locationId) {
      url = `/client/booking/instructor-profile/${id}?${formatStudioIdForQuery}`;
    } else if (submission_id && locationId) {
      url = `/client/booking/instructor-profile/${id}?submission_id=${submission_id}&${formatStudioIdForQuery}`;
    } else {
      url = `/client/booking/instructor-profile/${id}`;
    }
    const response = await http.getWithoutAuth(url);

    return response;
  }
}
